import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import SchemaView from './views/SchemaView';

class Schema extends React.Component {
    static propTypes = {
        spinner: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        const actview = new SchemaView();
        $('#schema_component').html($(actview.el));
        actview.render();
        this.props.spinner(false);
    }

    componentWillUnmount() {
        // remove all validation error messages
        $(document).validationEngine('hideAll');
    }

    render() {
        return (
            <div id="schema_component" />
        );
    }
}

export default Schema;
